// src/api/features/hotel-catalogue/index.ts
//
// Hotel static-data coverage: GET /api/v1/hotels/catalogue/coverage.

import { useQuery } from "@tanstack/react-query";

import { request } from "@/api/client";
import { PATHS } from "@/api/constants";

export type HotelCatalogueCoverageRow = {
  provider: "TBO" | "TRIPJACK";
  countryCode: string | null;
  countryName: string | null;
  cities: number;
  /** Cities whose hotel list has been loaded (on first search or by refresh). */
  citiesWithHotels: number;
  hotels: number;
  /** Hotels with photos/amenities loaded. */
  hotelsWithDetails: number;
  hotelsLastSyncedAt: string | null;
  oldestCityHotelsSyncedAt: string | null;
};

export type HotelCatalogueCoverage = {
  refreshDays: number;
  refreshEnabled: boolean;
  autoloadEnabled: boolean;
  countries: HotelCatalogueCoverageRow[];
};

type ApiEnvelope<T> = { ok: boolean; message?: string; data: T };

export async function getHotelCatalogueCoverage(): Promise<HotelCatalogueCoverage> {
  const res = await request<ApiEnvelope<HotelCatalogueCoverage>>({
    method: "GET",
    url: PATHS.hotelCatalogueAdmin.coverage,
  });
  return res.data;
}

export function useHotelCatalogueCoverage() {
  return useQuery<HotelCatalogueCoverage, Error>({
    queryKey: ["adminHotelCatalogue", "coverage"],
    queryFn: getHotelCatalogueCoverage,
    staleTime: 60_000,
  });
}
